<template>
  <div class="wrap" :class="namespace">
    <div class="header" :class="namespace">
      <div class="contacts" @click="toService" :class="namespace">
        <van-icon name="phone" class="icon" />联系客服
      </div>
    </div>
    <div class="main" :class="namespace">
      <div class="code-redeem">
        <div class="code-inp-wrap">
          <input
            class="code-inp"
            placeholder="请输入兑换码"
            v-model="inpValue"
          />
        </div>
        <div
          class="redeem-btn"
          :class="namespace"
          v-ans="{
            event_id: 'redeem_button',
          }"
          @click="handleDraw"
        >
          立即兑换
        </div>
      </div>
    </div>

    <div class="content" :class="namespace">
      <div v-if="!benefitList.length" class="empty-wrap">
        <p>空空如也，快去兑换吧！</p>
      </div>
      <div class="product" v-else>
        <div class="tip" :class="namespace" />
        <div>
          <p class="title">{{ cardTypeCn }}</p>
          <p class="time">
            会员有效期 {{ createTime | formatDate("YYYY.MM.DD") }}-{{
              endTime | formatDate("YYYY.MM.DD")
            }}
          </p>
        </div>
        <div class="btn-wrap">
          <div
            @click="toUse"
            v-ans="'redeem-use'"
            class="use-btn"
            :class="namespace"
          >
            去使用
          </div>
          <p v-if="['bgy', 'xtqqmusic'].includes(namespace)">
            剩余{{ benefitList[0].amount }}/{{ benefitList[0].amount_origin }}次
          </p>
        </div>
      </div>
    </div>
    <CommonPopup :show.sync="showPopup">
      <div class="popup-wrap" :class="namespace">
        <div class="popup-img"></div>
        <div class="popup-content">
          <h5>恭喜你兑换成功</h5>
          <p>{{ memberCardName }}</p>
          <div class="btn" @click="toUse">去使用</div>
        </div>
      </div>
    </CommonPopup>
  </div>
</template>

<script>
import {
  defineComponent,
  onMounted,
  ref,
  computed,
} from "@vue/composition-api";
import Vue from "vue";

import { goCashing } from "@/apis/home";
import { useRouter, useStore, useRoute } from "@/components/use/base";
import { getUserBenefit } from "@/apis/home";
import LoginDialog from "@/components/loginDialog";
import CommonPopup from "@/components/CommonPopup";
import ans from "@/utils/ans";

const vm = Vue.prototype;
// xtqqmusic
export default defineComponent({
  components: {
    CommonPopup,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const benefitList = ref([]);
    const inpValue = ref("");
    const showPopup = ref(false);

    const namespace = store.state.namespace;

    const isLogin = computed(() => !!store.state.token);
    const isMember = computed(() => store.state.isMember);
    const createTime = computed(() => store.state.userInfo.t_vip_created);
    const endTime = computed(() => store.state.userInfo?.card_expiry_date?.[0]);
    const cardTypeCn = computed(() => store.state.userInfo.card_type_cn);

    const memberCardName = computed(() => {
      return {
        licheng7: "热门会员优惠购",
        haixin: "热⻔移动端会员6选1季卡",
        hxxs24: "价值60元生活权益3选1",
      }[namespace];
    });

    const initData = async () => {
      const { data } = await getUserBenefit();
      data?.benefit_list?.length
        ? (benefitList.value = data.benefit_list)
        : (benefitList.value = []);
    };

    const handleDraw = async () => {
      if (!inpValue.value) {
        vm.$toast("请输入兑换码");
        return;
      }
      if (!isLogin.value) {
        vm.$toast("请先登录");
        await login();
      }
      const loading = vm.$loading();
      try {
        await goCashing({
          cashing_code: inpValue.value,
        });
        ans.pageView("common_redeem_exchange", {
          namespace: namespace,
        });
        store.dispatch("fetchUserInfo");
        initData();
        inpValue.value = "";
        if (namespace !== "bgy") {
          showPopup.value = true;
        }
      } catch (error) {
        console.log(error);
      } finally {
        loading.clear();
      }
    };

    const toUse = () => {
      const jumpToCommon = vm.$getConfigValue("JUMPTO_COMMON_REDEEM");
      if (jumpToCommon) {
        router.push("/common-redeem");
        return;
      }
      router.push("/dc-member");
    };

    const initRouterRedeem = () => {
      inpValue.value = route.query.redeem || "";
    };

    const login = async () => {
      const subtitle = vm.$getConfigValue("REDEEM_LOGIN_SUBTITLE");

      await LoginDialog.show({
        title: "手机号登录后使用",
        subtitle: subtitle ? subtitle : "",
        className: `__${namespace}-login`,
        needCheck: true,
        from: "redeem",
      });
      isMember.value && (await initData());
    };

    const toService = () => {
      router.push("/service");
    };

    onMounted(() => {
      ans.pageView("common_redeem_page", {
        namespace: namespace,
      });
      !isLogin.value ? login() : initData();
      initRouterRedeem();
    });

    return {
      toService,
      handleDraw,
      benefitList,
      createTime,
      endTime,
      toUse,
      inpValue,
      cardTypeCn,
      namespace,
      showPopup,
      memberCardName,
    };
  },
});
</script>

<style lang="less" scoped>
.wrap {
  background: #ecf9ff;
  min-height: 100vh;
  padding-bottom: 34px;
  &.cjyplus12,
  &.xmplus,
  &.cjymy01,
  &.cjyxmly01 {
    background: #fef6d1;
  }
  &.bgy {
    background: #fff5d0;
  }
  &.xtqqmusic {
    background: rgb(228, 246, 221);
  }
}
.header {
  background-repeat: no-repeat !important;
  background-size: 100% !important;
  height: 385px;
  position: relative;

  .contacts {
    position: absolute;
    display: flex;
    align-items: center;
    background: linear-gradient(270deg, #f39378 0%, #e35a43 100%);
    border-radius: 12px 0px 0px 12px;
    right: 0;
    top: 15px;
    padding: 1px 8px;

    font-size: 11px;
    color: #ffffff;
    line-height: 23px;
    text-align: center;
    .icon {
      margin-right: 4px;
    }
    &.xtqqmusic {
      background: #2bea88;
      color: #000000;
      font-weight: 600;
    }
  }
  &.licheng7 {
    background: url(https://common-h5-dev.xiangshuheika.com/static/upload/202410181fcfea31d5644.png);
    height: 356px;
    .contacts {
      background: linear-gradient(270deg, #f02140 0%, #f8425c 100%);
    }
  }
  &.haixin {
    background: url(https://common-h5-dev.xiangshuheika.com/static/upload/20241011f97c6afc031ef.png);
    height: 356px;
    .contacts {
      background: linear-gradient(270deg, #f02140 0%, #f8425c 100%);
    }
  }
  &.hxxs03 {
    background: url(https://common-h5-dev.xiangshuheika.com/static/upload/20251229cf686028ad4c4.png);
    height: 356px;
    .contacts {
      background: linear-gradient(270deg, #f02140 0%, #f8425c 100%);
    }
  }
  &.hxxs24 {
    background: url(https://common-h5-dev.xiangshuheika.com/static/upload/202507216e64b7c1ba02a.png);
    height: 356px;
    .contacts {
      background: linear-gradient(270deg, #f02140 0%, #f8425c 100%);
    }
  }
  &.dc_2407_test {
    background: url(https://common-h5-dev.xiangshuheika.com/static/upload/20240905b3ccaf052b19a.png);
    height: 385px;
  }
  &.jt_2412_test {
    background: url(https://common-h5-dev.xiangshuheika.com/static/upload/20241226514c7eb783eb3.png);
    height: 375px;
  }
  &.cjyxmly01 {
    background: url(https://common-h5-dev.xiangshuheika.com/static/upload/2025010667312b24233d1.png);
  }
  &.cjyplus12 {
    background: url(https://common-h5-dev.xiangshuheika.com/static/upload/2025010631ca8ea73a8c.png);
  }
  &.cjymy01 {
    background: url(https://common-h5-dev.xiangshuheika.com/static/upload/2025010656f6f8511d05d.png);
  }
  &.xmplus {
    background: url(https://common-h5-dev.xiangshuheika.com/static/upload/202505202faae0f676b5.png);
  }
  &.bgy {
    background: url(https://common-h5-dev.xiangshuheika.com/static/upload/20250820b1cf205c52f62.png);
  }
  &.xtqqmusic {
    background: url(https://common-h5-dev.xiangshuheika.com/static/upload/20251210e0ee70cae52e5.png);
  }
}
.main {
  margin: 0 12px;
  margin-bottom: 13px;
  background-repeat: no-repeat !important;
  background-size: 100% !important;
  height: 223px;
  position: relative;
  .code-redeem {
    position: absolute;
    box-sizing: border-box;
    overflow: hidden;
    border-radius: 16px;
    top: 85px;
    left: 50%;
    transform: translateX(-50%);
    .code-inp-wrap {
      margin: 0 auto;
      width: 294px;
      height: 44px;
      border-radius: 22px;
      border: 1px solid #b9b9b9;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .code-inp {
      border: none;
      width: 240px;
      &::placeholder {
        text-align: left;
        color: #999999;
        font-size: 14px;
      }
    }
    .redeem-btn {
      margin: 0 auto;
      margin-top: 16px;
      width: 294px;
      height: 44px;
      background: linear-gradient(270deg, #f39378 0%, #e35a43 100%);
      border-radius: 22px;
      font-family: AppleSystemUIFont;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      line-height: 44px;
      text-align: center;

      &.xtqqmusic {
        background: #000000;
        font-weight: 600;
        font-size: 14px;
        color: #ffffff;
      }
    }
  }
  &.haixin,
  &.licheng7 {
    background: url(https://common-h5-dev.xiangshuheika.com/static/upload/2024101108a309faa40bd.png);
    .redeem-btn {
      background: linear-gradient(270deg, #f02140 0%, #f8425c 100%);
    }
  }
  &.hxxs24,
  &.hxxs03 {
    background: url(https://common-h5-dev.xiangshuheika.com/static/upload/20250718a8609778447d5.png);
    .redeem-btn {
      background: linear-gradient(270deg, #f02140 0%, #f8425c 100%);
    }
  }
  &.dc_2407_test {
    background: url(https://common-h5-dev.xiangshuheika.com/static/upload/2024090521ab4c9c8a8ae.png);
  }
  &.jt_2412_test {
    background: url(https://common-h5-dev.xiangshuheika.com/static/upload/20241226307f73a044f89.png);
  }
  &.cjyxmly01,
  &.cjyplus12,
  &.xmplus,
  &.cjymy01 {
    background: url(https://common-h5-dev.xiangshuheika.com/static/upload/20250106afc876b5d3504.png);
  }
  &.bgy {
    background: url(https://common-h5-dev.xiangshuheika.com/static/upload/202508196ab257eaaed1f.png);
  }
  &.xtqqmusic {
    background: url(https://common-h5-dev.xiangshuheika.com/static/upload/202512106cb7db959b6fc.png);
  }
}
.content {
  margin: 0 12px;
  background-repeat: no-repeat !important;
  background-size: 100% !important;
  height: 183px;
  position: relative;
  overflow: hidden;
  &.dc_2407_test {
    background: url(https://common-h5-dev.xiangshuheika.com/static/upload/20240905b967ab09e9dc4.png);
  }
  &.haixin,
  &.licheng7 {
    background: url(https://common-h5-dev.xiangshuheika.com/static/upload/20241011861ca1f11166.png);
  }
  &.jt_2412_test {
    background: url(https://common-h5-dev.xiangshuheika.com/static/upload/20241226072b257f9584d.png);
  }
  &.cjyxmly01,
  &.cjyplus12,
  &.xmplus,
  &.cjymy01 {
    background: url(https://common-h5-dev.xiangshuheika.com/static/upload/20250106b6318b863dbde.png);
  }
  &.hxxs24,
  &.hxxs03 {
    background: url(https://common-h5-dev.xiangshuheika.com/static/upload/20250718d6a2884c6d01.png);
  }
  &.bgy {
    background: url(https://common-h5-dev.xiangshuheika.com/static/upload/20250819e82dce94a1d64.png);
  }
  &.xtqqmusic {
    background: url(https://common-h5-dev.xiangshuheika.com/static/upload/202512107a3abba0049bc.png);
  }
}
.empty-wrap {
  margin: 0 16px;
  margin-top: 105px;
  box-sizing: border-box;
  > p {
    font-weight: 400;
    font-size: 13px;
    color: #999999;
    line-height: 18px;
    text-align: center;
  }
}
.product {
  background: url(https://common-h5-dev.xiangshuheika.com/static/upload/20240905e4329db669c57.png);
  background-repeat: no-repeat;
  background-size: 100%;
  height: 83px;
  box-sizing: border-box;
  margin: 0 auto;
  margin-top: 72px;
  width: 316px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 8px 0 27px;
  .title {
    font-weight: 600;
    font-size: 13px;
    color: #333333;
    line-height: 18px;
  }
  .time {
    font-weight: 400;
    font-size: 10px;
    color: #666666;
    line-height: 14px;
    margin-top: 3px;
  }

  .btn-wrap {
    .use-btn {
      width: 60px;
      height: 26px;
      background: #fffefa;
      border-radius: 13px;
      text-align: center;
      font-weight: 500;
      font-size: 11px;
      color: #dc4f50;
      line-height: 26px;

      &.xtqqmusic {
        background: #000000;
        color: #ffffff;
      }
    }
    > p {
      font-weight: 400;
      font-size: 10px;
      color: #666666;
      line-height: 14px;
      text-align: center;
      margin-top: 4px;
    }
  }

  .tip {
    background-repeat: no-repeat !important;
    background-size: 100% !important;
    width: 62px;
    height: 23px;
    position: absolute;
    left: -7px;
    top: -4px;
    &.dc_2407_test,
    &.jt_2412_test {
      background: url(https://common-h5-dev.xiangshuheika.com/static/upload/20240905d4b80bd303de4.png);
    }
    &.haixin {
      background: url(https://common-h5-dev.xiangshuheika.com/static/upload/20241011f92eef53576a9.png);
    }
    &.licheng7 {
      background: url(https://common-h5-dev.xiangshuheika.com/static/upload/20241018e434c84939d1c.png);
    }
    &.bgy {
      background: url(https://common-h5-dev.xiangshuheika.com/static/upload/20250819c29fdb3a1655a.png);
      &::before {
        content: "月卡5选1";
        font-weight: 500;
        font-size: 10px;
        line-height: 18px;
        text-align: center;
        margin-left: 7px;
        color: #ffffff;
      }
    }
  }
}
.popup-wrap {
  padding-top: 49px;
  overflow: hidden;
  position: relative;
  .popup-img {
    width: 103px;
    height: 87px;
    position: absolute;
    background: url("https://common-h5-dev.xiangshuheika.com/static/upload/2024101272fd70091f402.png");
    background-repeat: no-repeat !important;
    background-size: 100% !important;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }
  .popup-content {
    width: 332px;
    height: 264px;
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
    > h5 {
      margin-top: 74px;
      margin-bottom: 0;
      font-weight: 500;
      font-size: 16px;
      color: #000000;
      line-height: 22px;
      text-align: center;
    }
    > p {
      margin-top: 4px;
      font-weight: 500;
      font-size: 24px;
      color: #000000;
      line-height: 33px;
      text-align: center;
    }
    > .btn {
      margin: 43px 19px 0 19px;
      height: 44px;
      background: linear-gradient(270deg, #f39378 0%, #e35a43 100%);
      border-radius: 22px;
      font-weight: 400;
      font-size: 16px;
      color: #ffffff;
      line-height: 44px;
      text-align: center;
    }
  }
  &.haixin,
  &.licheng7 {
    .btn {
      background: linear-gradient(270deg, #f02140 0%, #f8425c 100%);
    }
  }
  &.xmplus {
    height: 290px;
    background: linear-gradient(180deg, #ffd5d5 0%, #ffffff 100%);
    border-radius: 8px;
    box-sizing: border-box;
    .popup-img {
      top: 25px;
    }

    .popup-content {
      background: none;
      > h5 {
        margin-top: 90px;
      }
    }
    .btn {
      margin-top: 44px;
      background: linear-gradient(270deg, #ff4713 0%, #ff7953 100%);
    }
  }
}
</style>

<style lang="less">
.__dc_2407_test-login {
  .van-button {
    background: #e35a43;
    color: #fff;
  }
}
.__haixin-login,
.__licheng7-login {
  .van-button {
    background: linear-gradient(270deg, #f02140 0%, #f8425c 100%);
    color: #fff;
  }
}
.__xmplus-login {
  background: linear-gradient(180deg, #ffd5d5 0%, #ffffff 100%);
  padding-bottom: 28px;
  border-radius: 16px;

  .login-desc {
    color: #999999;
    font-size: 12px;
  }

  .field-input {
    width: auto;
    background: #ffffff;
    border-radius: 8px;
    margin-bottom: 8px;
    margin-left: 8px;
    margin-right: 8px;
  }

  .van-button {
    background: linear-gradient(270deg, #ff4713 0%, #ff7953 100%);
    color: #ffffff;
  }

  .form-submit {
    margin-top: 0;
  }

  .login-header {
    padding-bottom: 20px;
  }

  .code {
    border: none;
    font-weight: 500;
    font-size: 12px;
    color: #fc283e;
    line-height: 27px;
  }
  .dialog-close {
    left: 12px;
    top: 12px;
    background: url("../../../assets/images/white-cancel.png") !important;
    background-size: 100% !important;
    height: 12px;
    width: 12px;
  }
}

.__bgy-login {
  .van-button {
    background: #ff5100;
    color: #fff;
  }
}
</style>
